export default "__VITE_ASSET__17799346__"